import { useGomakeTheme } from "@/hooks/use-gomake-thme";

const AddIcon = ({ color = "var(--theme-primary-color, #2E3092)" }) => {
  const { primaryColor } = useGomakeTheme();
  const strokeColor = color || primaryColor(500);
  
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6673 7.99992V5.99992C14.6673 2.66659 13.334 1.33325 10.0007 1.33325H6.00065C2.66732 1.33325 1.33398 2.66659 1.33398 5.99992V9.99992C1.33398 13.3333 2.66732 14.6666 6.00065 14.6666H8.00065"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.9738 11.8932L12.8871 12.2599C12.5871 12.3599 12.3471 12.5933 12.2471 12.8999L11.8804 13.9866C11.5671 14.9266 10.2471 14.9066 9.95377 13.9666L8.72044 9.99991C8.48044 9.21325 9.2071 8.47991 9.9871 8.72658L13.9604 9.95992C14.8938 10.2532 14.9071 11.5799 13.9738 11.8932Z"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { AddIcon };
